import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
//import { withRouter } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl,  mediaUrl } from '../Config/Config';
import axios from 'axios';
import { Scrollbars } from 'react-custom-scrollbars';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
  

		
class Edit extends Component {
	
	fileObj = [];
    fileArray = [];
    imageArray = [];
	
	constructor(props)
	{
		CheckAuth();
		super(props);	
		const editId = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;

		//this.state =  { ...initialState }
		this.state = {
			editId: editId,
			name:'',
			description:'',
			link:'',			
			button_text:'',		
			landing_type: '',	
			module_type:'',
			module_type_value:'',
			selectedvalue: '',
            selectedOption:{ value: 'active', label: 'Active'},
			selectedsizevalue: '',
            selectedsizeOption:{ value: '350x350', label: '350x350'},
			user_image: [],
			user_image_name: [],
			user_image_preview: [],
			image: [],
			icon:null,
			icon_preview : '',
			isHidden: false,
			statusmessage:'',
			selectedVehicle:'',
			vehiclevalue:'',
			Loading:false,
			fileName: [],
			thumbDefault: null,
			priority: "",			
			selectedCateOption: '',
			selectedCatevalue:'',
			admin_id: localStorage.getItem('admin_id'),
			enableuploadgalley: false,
			imagelist:[],
			selectedimages:[],
			galleryimg: 'No',
			old_image:'',
			selectedImage:null,
			unlinkImage: null,
			imageUsageMessage: '',
			showUnlinkConfirm: false,
			showUsageWarning: false,
			featured: false,
			show_label:true
		}
	   this.handleInputChange = this.handleInputChange.bind(this);
	   this.handleChange = this.handleChange.bind(this);
	   //this.handleReset = this.handleReset.bind(this);
	   this.handlesizeChange = this.handlesizeChange.bind(this);
	   this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this);
	   this.onEditorChange = this.onEditorChange.bind( this );
	   this.onEditorAIChange = this.onEditorAIChange.bind( this );
    }
	
	listloaddata=()=>{
		axios.get(apiUrl+"creditcard/getimagelist").then(res => {
			if(res.data.status == 'success'){
				console.log( res.data.imagelist);	
				this.setState({imagelist:res.data.imagelist});
			}
		});

		var qs = require('qs');
		axios.get(apiUrl+"creditcard/listdetail?id="+this.state.editId).then(res => {
			if(res.data.status == 'success'){
				const formdata = res.data.listdetail;	
				this.setState({editid:1,image_preview:formdata.images,old_image:formdata.images})
					if(formdata.status === 'A'){
						this.setState({selectedOption:{value: 'active', label: 'Active'}});
					}else{
						this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
					}
					
					
					// console.log(res.data.galleries,"res.data.galleriesres.data.galleries")
					this.setState({
						name:formdata.name,
						description:formdata.description,
						link:formdata.link,
						editId: formdata.id,
						button_text:formdata.button_text,
						old_image:formdata.images,
						featured: formdata.featured === 'yes' ? true : false,
						show_label: formdata.show_label === 'yes' ? true : false
					});
				
				
				console.log(lang.common.cardCategories_option,'lang.common.cardCategories_option')
				const cateOption = lang.common.cardCategories_option.find(option => option.value === formdata.cate_id);
            	this.setState({selectedCateOption:cateOption,selectedCatevalue:cateOption['value']});
				if(formdata.card_type !=null && formdata.card_type !=''){
					console.log("card type,formdata.card_type")
					const cardOption = lang.common.card_type.find(option => option.value === formdata.card_type);
                   	this.setState({selectedCardtypeOption:cardOption,selectedCardtypevalue:cardOption['value']});	
				}	
			}	
			
			
		}); 
		
		
	}


	onEditorChange = (evt, fieldName) => {
		const data = evt.editor.getData();
		this.setState({ [fieldName]: data });
		$('.errordescription').html('');
	};

    handleChange = (r,selOption) => {
        //this.setState({selectedOption})
        //this.setState({  selectedvalue : selectedOption.value});
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'cate'){			
			this.setState({selectedCateOption:selOption})
			this.setState({  selectedCatevalue : selOption.value});
		}
		else if(r == 'cardtype'){			
			this.setState({selectedCardtypeOption:selOption})
			this.setState({  selectedCardtypevalue : selOption.value});
		}
		
    };
	handlesizeChange = selectedsizeOption => {
        this.setState({selectedsizeOption})
        this.setState({  selectedsizevalue : selectedsizeOption.value});
		
    };
   handleInputChange(event) {

      const {name, value} = event.target;    
      this.setState({
          [name]: value
        });
	   $('.error'+name).html('');
    }

	componentDidMount() {
		document.title = PageTitle('Edit Credit card detail');
		this.listloaddata();
    }

  


onThumbChanged = (e) => {
    this.setState({
      thumbDefault: e.currentTarget.value
      });
  }
  
uploadMultipleFiles = (e) =>{

		this.fileObj = [];
        this.fileObj.push(e.target.files)
        for (let i = 0; i < this.fileObj[0].length; i++) {
            this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
            //this.fileArray.push(this.fileObj[0][i])
            this.imageArray.push(this.fileObj[0][i])

        }
        this.setState({ user_image: this.imageArray, editid:0 });			
	
    }
	
	 handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				 const config = {
			        headers: {
			          'Content-Type': 'multipart/form-data'
			        }
			      };

				const formPayload = this.state;
				var qs = require('qs');
				var status, cate,cardtype = '';

				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}

				
				
				if(formPayload.selectedCatevalue === '' && formPayload.selectedCatevalue!== 0){
					cate =formPayload.selectedCateOption.value;
				}else{
					cate = formPayload.selectedCatevalue;
				}

				if(formPayload.selectedCardtypeOption === '' && formPayload.selectedCardtypeOption!== 0){
					cardtype =formPayload.selectedCardtypeOption.value;
				}else{
					cardtype = formPayload.selectedCardtypevalue;
				}
				
					
				var imgSize = '';
				if(formPayload.selectedsizevalue === ''){
				imgSize =formPayload.selectedsizeOption.value;
				}else{
				imgSize = formPayload.selectedsizevalue;
				}
                
                // var galleryimg = 'No';
				// if(Object.keys(formPayload.selectedimages).length >0){
                //    galleryimg = 'Yes';
				// }
				var image_name = formPayload.old_image;
				if (this.state.galleryimg === 'Yes' && formPayload.selectedImage) {
					image_name = formPayload.selectedImage.name;
				}

				var postObject = {
					id: formPayload.editId,
					admin_id : localStorage.getItem("admin_id"),
					name: formPayload.name,
                    description: this.state.description,
					link:formPayload.link,
					button_text:formPayload.button_text,
					status      :status,
					cate_id:cate,
					card_type:cardtype,
					old_image: image_name,
					featured: formPayload.featured ? 'yes' : 'no',
					show_label: formPayload.show_label ? 'yes' : 'no'
				};

				
				console.log(postObject,'-postObject');
				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}
                if(this.state.galleryimg === 'No'){
                   var icondata = formPayload.icon;
				   formData.append('image',icondata)
				}
					
							
				axios.post(apiUrl+"creditcard/edit",formData,config).then(res => {
				 
					if(res.data.status === 'success'){
					   $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
					   setTimeout(
						function() {
							this.props.navigate('/creditcard');
						}
						.bind(this),
						3000
						);
						localStorage.removeItem('ad_content')
						 //  console.log('success edit')
					   }else{
						this.setState({Loading:false});
						   $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						   setTimeout(
						   function() {
							   $('.success_message').html('');
						   }
						   .bind(this),
						   3000
						   );
					   }
				  }); 
			}
	}


	mapModulesToSelect = (moduleString) => {
		const moduleArray = moduleString.split(',');

		const options =
			this.state.user_type_value === 'choose'
				? lang.common.before_login_ads_options
				: this.state.user_type_value === 'user'
				? lang.common.user_ads_options
				: this.state.user_type_value === 'lender'
				? lang.common.lender_ads_options
				: this.state.user_type_value === 'investor'
				? lang.common.investor_ads_options
				: this.state.user_type_value === 'broker'
				? lang.common.broker_ads_options
				: this.state.user_type_value === 'salesperson'
				? lang.common.sales_ads_options
				: this.state.user_type_value === 'company'
				? lang.common.company_ads_options
				: lang.common.field_options;

		const selectedOptions = options.filter(opt =>
			moduleArray.includes(opt.value)
		);

		this.setState({
			module_type: selectedOptions,
			module_type_value: moduleArray
		});
	};

    validateForm() {
			const {name,link,icon,description,button_text,selectedvalue,selectedCateOption,old_image,selectedImage} = this.state;
			console.log(selectedvalue,"selectedvalue");
			let errors = 0;
			const cleanDescription = description
			 ? description.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim()
		: '';
		const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/svg+xml'];
			let maxSize = 1000000;//1 mb
			if (!name) {
				errors++;
				console.log("error1");
				$('.errorname').html('<span class="errorspan">Please fill the field</span>');
			}else if(name){
				$('.errorname').html('');
			}
			if (!link) {
				errors++;
				console.log("error1");
				$('.errorlink').html('<span class="errorspan">Please fill the field</span>');
			}else if(link){
				$('.errorlink').html('');
			}
			if (!button_text) {
				errors++;
				console.log("error1");
				$('.errorbutton_text').html('<span class="errorspan">Please fill the field</span>');
			}else if(button_text){
				$('.errorbutton_text').html('');
			}
			if(selectedCateOption == ''){
				errors++;
				$('.errorcate').html('<span class="errorspan">Please select a value</span>');
			}else {
				$('.errorcate').html('');
			}
	
	
			if (!cleanDescription) {
				errors++;
				console.log("error2");
				$('.errordescription').html('<span class="errorspan">Please fill the field</span>');
			} else {
				$('.errordescription').html('');
			}
			
			if((icon== null || icon == '' ) && old_image=='' && selectedImage==null){
				errors++;
				$('.errorimage').html('<span class="errorspan">Please upload image</span>');
			}
			// else if(user_image) {	 
				
			//          for (let i = 0; i < user_image.length; i++) 
			// 		 {
	
			// 			const file = user_image[i];
			// 			const filename = file.name;
	
						
			// 			if (!allowedTypes.includes(file.type)) {
			// 				errors++;
						
			// 			$('.erroradimage').html('<span class="errorspan"> '+filename+' file type is Invalid.</span>');
	
			// 			continue;
			// 			}
			//         }
			//    }
	
	
			if(errors>0) { console.log('validation error')
				setTimeout(function () {
				scrollToTopValidate();
				}, 100);
				return false;
			}
			else { console.log('validation error no')
			return true;
			}
	
		}


    
	removeImagebyindex = (indexvalue) => {
  	 
	  var list = [...this.imageArray];
	  this.imageArray = [];
	  this.fileArray = [];
	  list.splice(indexvalue, 1);
	 
	  for (let i = 0; i < list.length; i++) {
		this.imageArray.push(list[i]);
		this.fileArray.push(URL.createObjectURL(list[i]));
	  }
	
		this.setState({ user_image: this.imageArray })
		
		var thumbDefault = this.state.thumbDefault;
		if(indexvalue <= thumbDefault){
			let thum = thumbDefault-1;
			 if(thum < 0 ){
			   this.setState({thumbDefault : 0})
			 }else{
				this.setState({thumbDefault : thum});
			}    
		}
	}
	
	
	 getImagesFrontUpload(){
		 /*====Thumb image while choosing from front end===*/
		  if(Object.keys(this.fileArray).length > 0) {
			//var thumbDefaultArr = this.state.thumbDefault;
		 
			 const imgThumblist = this.fileArray.map((url, index) => {
						//var indicheckFlag = false;
												
						//if(Object.keys(thumbDefaultArr).length > 0){
							// if(thumbDefaultArr != null && thumbDefaultArr == index){
							// 	indicheckFlag = true;
							// }
						//}
						  	return (
							<li className="thumb" key={index}  >
								{/* <input type="radio" name="sel_img" id="sel_img"  value={index} onClick={this.onThumbChanged} checked={indicheckFlag} /> */}
								<span><img src={url}  alt="..." /></span>
								<a href="javascript:void(0);" onClick={this.removeImagebyindex.bind(this,index)}>X</a>
							</li>
							);
			 });	
				return imgThumblist;					
			/*=======*/
		}
	 }

   //list selected image  from gallery
	 getafteruploaded(){
	 	var imgArray = this.state.selectedimages;
	 	if(Object.keys(imgArray).length > 0) {
		 	//var thumbDefaultArr = this.state.thumbDefault;
			 	const imgThumblist = imgArray.map((images, index) => {
			 	//console.log(images,'images')
			 			// var indicheckFlag = false;
		 				// if(thumbDefaultArr != null && thumbDefaultArr == index){
						// 	indicheckFlag = true;
						// } 
						return (
							<li className="thumb" key={index}  >
								{/* <input type="radio" name="sel_img" id="sel_img"  value={index} onClick={this.onThumbChanged} checked={indicheckFlag} /> */}
								<span><img src={mediaUrl+'advertisement/'+images}  alt="..." /></span>
								<a href="javascript:void(0);" onClick={this.removeImagebyindex.bind(this,index)}>X</a>
							</li>
						);
			 });	
				return imgThumblist;					
			/*=======*/
		}

	 }
  //check gallery images
   Checkgallery = (indexs,value) =>{
      var imageArr = [...this.state.selectedimages];
      const index = imageArr.findIndex(images => images === indexs);
      if(index > -1) {
     	 imageArr = [...imageArr.slice(0, index), ...imageArr.slice(index + 1)]
      } else {
      imageArr.push(value);
      }
      this.setState({selectedimages: imageArr});
  }

selectGalleryImage = (image) => {
    this.setState((prevState) => {
        const selectedImage =
            prevState.selectedImage?.name === image.name
                ? null
                : image;

        if (selectedImage) {
            // Fetch the image from URL and create a File object
            fetch(selectedImage.url)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], selectedImage.name, { type: blob.type });
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        this.setState({
                            icon: file,
                            icon_name: selectedImage.name,
                            icon_preview: reader.result,
                            icon_fileExtension: selectedImage.name.split('.').pop()
                        });
                    };
                    reader.readAsDataURL(blob);
                });
        }

        return {
            selectedImage,

            ...(selectedImage && {
				galleryimg: 'Yes',
				enableuploadgalley:false
            })
        };
    });
};

	handleUnlinkClick = (image, e) => {
		e.stopPropagation();
		e.preventDefault();
		axios.get(apiUrl + "creditcard/checkimageusage?imagename=" + image.name)
			.then(res => {
				if (res.data.status === 'success' && res.data.usagecount > 0) {
					this.setState({
						unlinkImage: image,
						//imageUsageMessage: `This image is used in ${res.data.usagecount} listing(s) and cannot be unlinked.`,
						imageUsageMessage:'This image is currently in use and cannot be removed',
						showUsageWarning: true
					});
				} else {
					this.setState({ unlinkImage: image, showUnlinkConfirm: true });
				}
			});
	};

	confirmUnlink = (answer) => {
		if (answer === 'yes') {
			const { unlinkImage } = this.state;
			const qs = require('qs');
			axios.post(apiUrl + "creditcard/unlinkimage", qs.stringify({ imagename: unlinkImage.name }))
				.then(res => {
					if (res.data.status === 'success') {
						this.setState(prev => ({
							imagelist: prev.imagelist.filter(img => img.name !== unlinkImage.name),
							selectedImage: prev.selectedImage?.name === unlinkImage.name ? null : prev.selectedImage,
							unlinkImage: null,
							showUnlinkConfirm: false,
							//enableuploadgalley: false
						}));
						$('.success_message').html('<div class="status_sucess"><h3>Image successfully unlinked from folder</h3></div>');
						setTimeout(() => {
							$('.success_message').html('');
						}, 3000);
					}
				});
		} else {
			this.setState({ unlinkImage: null, showUnlinkConfirm: false });
		}
	};

 getGalleryimages=()=> {
    var imageArr = this.state.imagelist;
    if(imageArr!== undefined && imageArr!== null){
      if(Object.keys(imageArr).length > 0) {
         const imageDetails = imageArr.map((image, Index) => {
       		var checked = false;
            return (
                        <div className="asp-col" key={Index}>   
                        <input className='ms-0' type="checkbox" name="gallery_img" value={Index}  onClick={this.Checkgallery.bind(this,Index,image['name'])} />
                        <label><img src={image['url']} alt="" className="" /></label>
                        </div>
                     );
    
     });
      return imageDetails;
     }
    } else {
      return (<div className="">No images found</div>);
    }
  }
  galleryClose = () => {
	this.setState(prevState => ({
		enableuploadgalley: !prevState.enableuploadgalley
	}));
   }
//    galleryClose = () => {

//    		if(Object.keys(this.state.selectedimages).length > 0){
//    			 this.setState({galleryimg: 'Yes'});
//    		}
//    	    this.setState(prevState => ({
// 			enableuploadgalley: !prevState.enableuploadgalley
// 		}));
// 		$('.cargallery-popup').removeClass('active');
//    }

   	// handlefieldTypeChange(event) {   
	// 	this.setState({module_type:[event],module_type_value:event.value})
	// }
	handlefieldTypeChange(event) {   
		this.setState({module_type:event.value,module_type_value:event.value})
	}

	// handlefieldTypeChange = (selectedOptions) => {
	// 	this.setState({
	// 		module_type: selectedOptions || [],
	// 		module_type_value: selectedOptions
	// 			? selectedOptions.map(item => item.value)
	// 			: []
	// 	});
	// };

	handleadsfieldTypeChange(event) {   
		this.setState({module_type:'',module_type_value:''})
		this.setState({user_type:[event],user_type_value:event.value})
	}

   onChangeHandler=event=>{
	let reader = new FileReader();
	const file = event.target.files[0];
	const extension = file.name.split('.').pop();
	reader.onloadend = () => {
	  this.setState({
		icon_name: file.name,
		icon_preview: reader.result,
		icon: file,
		icon_fileExtension:extension,
		selectedImage:null,
		galleryimg: 'No',
		enableuploadgalley:false
		
	  },()=>{
		console.log(this.state.icon,'-icon')
	  });
	};
	reader.readAsDataURL(file);
	
  } 

  onEditorAIChange( evt ) {

	var callfunc = this;

	setTimeout(function () {

	 this.setState( {

		 description: evt

	 },()=>{
	 } );
	 }.bind(this),1000);

}

renderGalleryImages = () => {
    const imageArr = this.state.imagelist;

    if (!imageArr || imageArr.length === 0) {
        return <li>No images found</li>;
    }

    return imageArr.map((image, index) => (
        <li
            className="gallery-multiselect-item position-relative"
            key={index}
        >
            {/* <span
                className="gallery-unlink-btn close-text position-absolute"                
                onClick={(e) => this.handleUnlinkClick(image, e)}
            >
                ×
            </span> */}

			{image.used === 'in_use' ? (
					<span className="gallery-inuse-badge position-absolute top-0 end-0 chip pointer-events-none">
						In use
					</span>
				) : (
					<span
						className="gallery-unlink-btn close-text position-absolute"                
						onClick={(e) => this.handleUnlinkClick(image, e)}
					>
						×
					</span>
				)}

            <input
                type="checkbox"
                className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
                value={image.name}
                checked={this.state.selectedImage?.name === image.name}
                onChange={() => this.selectGalleryImage(image)}
            />

            <i className="gallery-multiselect-tick-icon backforth-slideLeft position-absolute">
                <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 457.57"
                >
                    <path
                        className="cls-1"
                        d="M0,220.57c100.43-1.33,121-5.2,191.79,81.5,54.29-90,114.62-167.9,179.92-235.86C436-.72,436.5-.89,512,.24,383.54,143,278.71,295.74,194.87,457.57,150,361.45,87.33,280.53,0,220.57Z"
                    />
                </svg>
            </i>

            <img
                src={image.url}
                alt={image.name || ''}
            />
        </li>
    ));
};
  render() {
	console.log(this.state.selectedCateOption,this.state.imagelist, "this.state.selectedCateOption")
	
	const {selectedOption,selectedCateOption, user_image_preview,selectedLinkOption, user_type_value, selectedCardtypeOption} = this.state;
    const filteredPageOptions = this.state.userTypeVal
			? lang.common.pageOption.filter(
				item => item.type === this.state.userTypeVal
				)
			: [];
	 const filteredlinkOptions = this.state.userTypeVal
			? lang.common.field_options.filter(
				item => item.type === this.state.userTypeVal
				)
			: [];
    const selectedOptiondata = filteredlinkOptions.find(option => option.value === this.state.module_type_value);

	console.log(this.state.enableuploadgalley,"enableuploadgalley");
	
	var	preview = (this.state.icon_preview) ? 
		<img className="img_class" src={this.state.icon_preview} alt="" /> :
		<img className="img_class"   src={
            mediaUrl +
            'creditcard/' +
            (
                this.state.selectedImage
                    ? this.state.selectedImage.name
                    : this.state.old_image
            )
        } alt="" />
		;
	

    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="creditcard" />  

	
	<div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
		   <div className="form-wrapper leaa-admin-head card">

				<div className="success_message"></div>
				<div>
					<a class="primary-btn" href="/creditcard">Back</a>
				</div>
				<div className="title">
					<h4>Edit Credit Card</h4>
				</div>
				<form className="login" id="login" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>
				<div className="form-row">
					<div className="form-left">
						<div className="form-group">
							<label>Title<span class="required" style={{ color: "red" }} > * </span>:</label>
							<input type="text" name="name" onChange={this.handleInputChange} className="form-control" value={this.state.name} />
							<div className="errorname"></div>
						</div>
						
						
						<div className="form-group">
							<label>Button Text<span class="required" style={{ color: "red" }} > * </span>:</label>
								<input type="text" name="button_text" onChange={this.handleInputChange} className="form-control" value={this.state.button_text} />
							<div className="errorbutton_text"></div>
						</div>
						<div className="row">
							<div className="col-xl-6 col-12">
								<div className="form-group">
									<label className="d-flex align-items-center gap-2">
										<input
											type="checkbox"
											checked={this.state.featured}
											onChange={(e) => this.setState({ featured: e.target.checked })}
											className="form-check-input"
											style={{ margin: 0 }}
										/>
										<span>Show as Featured</span>
									</label>
									
								</div>
							</div>
							<div className="col-xl-6 col-12">
								<div className="form-group">
									<label className="d-flex align-items-center gap-2">
										<input
											type="checkbox"
											checked={this.state.show_label}
											onChange={(e) => this.setState({ show_label: e.target.checked })}
											className="form-check-input"
											style={{ margin: 0 }}
										/>
										<span>Show Label</span>
									</label>
								</div>
							</div>
						</div>
												
							<div className="form-group">
							<label>Description<span class="required" style={{ color: "red" }} > * </span>:</label>
								{/* <CKEditor
								data={this.state.description}
								onChange={(evt) => this.onEditorChange(evt, 'description')}
								type="classic"
								/>	 */}
								<CKEditor
									editor={ ClassicEditor }
									data={this.state.description}
									onReady={ editor => {
										// You can store the "editor" and use when it is needed.
										console.log( 'Editor is ready to use!', editor );
										editor.ui.view.editable.element.style.minHeight = "300px";
									} }
									name="ad_description"
									// onChange={this.handleInputChange}
									onChange={ ( event, editor ) => {
										const data = editor.getData();
										this.setState({description: data});
										editor.ui.view.editable.element.style.minHeight = "300px";
										
									} }
																	/>
							<div className="errordescription"></div>
						</div>
						
						
					</div>				
					
	
					<div className="form-right">
						<div className="form-group">					
							<label>Category<span class="required" style={{ color: "red" }} > * </span> :</label>
							<Select 
							value={selectedCateOption?selectedCateOption:""}
								options={lang.common.cardCategories_option} 
								onChange={this.handleChange.bind(this, 'cate')}
								/>
								<div className="errorcate"></div>
						</div>
						<div className="form-group">					
							<label>Card Type :</label>
							<Select 
							value={selectedCardtypeOption?selectedCardtypeOption:""}
								options={lang.common.card_type} 
								onChange={this.handleChange.bind(this, 'cardtype')}
								/>
								<div className="errorcate"></div>
						</div>
						
						<div className="form-group">
							<label>Link Url<span class="required" style={{ color: "red" }} > * </span>:</label>
							<input type="text" name="link" onChange={this.handleInputChange} className="form-group" value={this.state.link} />
							<div className="errorlink"></div>
						</div>
									
						<div className="form-group">
							{/* <label className=''>Creditcard Image : <span class="required" style={{ color: "red" }} > * </span></label> */}

						   
							{/* <span className=''>Image (jpeg,jpg,png,svg)</span> */}
							<div className='d-flex gap-3 flex-wrap align-items-center'>
							

							<div className=''>
								<label className="form-label fw-semibold">Upload credit card image  (jpeg,jpg,png,svg):</label>
								<div className="d-flex gap-3 flex-wrap align-items-center">
									<i onClick ={()=>this.setState({enableuploadgalley:true})}><svg width="20px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="4.76 4.76 90.49 90.48">  <path d="m95.238 82.742v11.203c0 1.4141-1.4375 1.293-2.1523 1.293h-87.035c-1.4141 0-1.293-1.4375-1.293-2.1523l0.003907-11.203c0-1.4141 1.4375-1.293 2.1523-1.293h87.031c1.418 0 1.293 1.4336 1.293 2.1523zm-30.668-44.543v34.586h-29.141v-34.586h-16.645c-1.1523 0-1.7305-1.3906-0.91406-2.207l30.605-30.602c0.83984-0.83984 2.207-0.83984 3.0469 0l30.605 30.605c0.81641 0.81641 0.23828 2.207-0.91406 2.207z"></path> </svg>
									</i>
									{preview}
								</div>
							</div>																				
							
						</div>					
							
							{/* {image_preview?<a href="javascript:void(0);">X</a>:''} */}
							<div className="errorimage"></div>  
						</div> 
					

                        <div className="form-group">					
							<label>Status:</label>
							<Select 
							value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
							options={lang.common.status_option} 
							onChange={this.handleChange.bind(this, 'status')}
							isSearchable={false}
							/>
							
						</div>
						

					
					</div>
				</div>		

				<div className="btn-group export">
					<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&	<span className="load-data"></span> }Submit </button>
				</div>
			</form>
			</div>
		</div>

		<div className={`popup-sec popup-upload-media ${this.state.enableuploadgalley ? 'active' : ''}`}>   
			<div className='popup-sec-in'>
				<span className='popup-close position-absolute cursor-pointer' onClick ={()=>this.galleryClose()}>X</span>
				<div className='d-flex mb-4'>
					<div className="upload-file-icon upload-file-with-label position-relative cursor-pointer lh-1 d-flex align-items-baseline gap-20px">
					<input type="file" className="position-absolute top-0 opacity-0 h-100 w-100 cursor-pointer" />
					<p className="fw-semibold m-0 me-2">Upload from device</p>
						<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
					
					{/* <svg className='pointer-events-none' width="20px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="4.76 4.76 90.49 90.48">  <path d="m95.238 82.742v11.203c0 1.4141-1.4375 1.293-2.1523 1.293h-87.035c-1.4141 0-1.293-1.4375-1.293-2.1523l0.003907-11.203c0-1.4141 1.4375-1.293 2.1523-1.293h87.031c1.418 0 1.293 1.4336 1.293 2.1523zm-30.668-44.543v34.586h-29.141v-34.586h-16.645c-1.1523 0-1.7305-1.3906-0.91406-2.207l30.605-30.602c0.83984-0.83984 2.207-0.83984 3.0469 0l30.605 30.605c0.81641 0.81641 0.23828 2.207-0.91406 2.207z"></path> </svg>                               */}
					</div>
					{/* {preview} */}
				</div>
				<ul className="gallery-multiselct-sec d-flex gap-4 flex-wrap mt-30px">
					{this.renderGalleryImages()}
				</ul>

				{/* <div className="d-flex justify-content-end gap-4 mb-4">
					<button
						className="btn"
					>
					Deslect all
					</button>
					<button
						className="btn"
					>
					Select
					</button>
				</div> */}
			</div>
		</div>	

		{this.state.showUnlinkConfirm && (
			<div className="confirm-action show">
				<p>Are you sure you want to unlink this image from the gallery?</p>
				<a href="javascript://" onClick={() => this.confirmUnlink('yes')} className="btn">Yes</a>
				<a href="javascript://" onClick={() => this.confirmUnlink('no')} className="btn">No</a>
			</div>
		)}

		{this.state.showUsageWarning && (
			<div className="confirm-action show">
				<p>{this.state.imageUsageMessage}</p>
				<a href="javascript://" onClick={() => this.setState({ showUsageWarning: false, unlinkImage: null })} className="btn">OK</a>
			</div>
		)}
	</div>
    </div>
    );
  }
}


export default (withRouter(Edit));
